import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Rynco Li
 * id 45A9D669-8244-476D-A148-21EAB63F819B
 * name card-text-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-text-outline.svg
 * tags
 */
export const CardTextOutlineIcon = createSvgIcon(<><path d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z" /></>, 'CardTextOutlineIcon');
export default CardTextOutlineIcon